<template>
  <div class="deposit-amount-input-wrap">
    <!-- ── PayPal：固定金額選擇 ── -->
    <div v-if="typeCode === 'PayPal'" class="fastDepositFrame">
      <div class="FD-title text-center">
        {{ $t('Bao.prize_select') }}
      </div>
      <div class="FD-amount-box">
        <div
          v-for="(price, key) in priceList"
          :key="key"
          class="FD-amount-item"
          :class="{ active: selectedAmount === price }"
          @click="$emit('select-amount', price)"
        >
          {{ currencySymbol }}{{ price }}
        </div>
      </div>
    </div>

    <!-- ── 金額範圍提示（Mobile 非買幣模式） ── -->
    <div
      v-if="showRangeBar && typeCode !== 'CcPayment' && paymentCode !== 'AmoPay'"
      class="mb-form-range-bar"
    >
      {{ $t('Bao.min_to_max') }}
      <span class="mb-form-range-value">
        {{ parseInt(amountMin) }} - {{ parseInt(amountMax) }}
      </span>
    </div>

    <!-- ── 一般金額輸入（非加密幣、非 PayPal、非 JetonCash） ── -->
    <div
      v-if="typeNum !== 3 && typeCode !== 'JetonCash'"
      class="input-amount-group"
    >
      <!-- PC 有 input-title，Mobile 無，統一用 slot 或 prop 控制 -->
      <div class="form-input-n input-frame input-dep-amount-frame">
        <div v-if="showLabel" class="input-title">
          {{ $t('Bao.amount') }} :
        </div>
        <div class="input-amount">
          <input
            :value="amount"
            class="input-amount-content"
            type="text"
            placeholder="0"
            @input="$emit('input', $event)"
          >
          <span class="currency">{{ isAmoPay ? 'USD' : currency }}</span>
        </div>
      </div>

      <!-- 買幣模式 slider（非 AmoPay） -->
      <div v-if="isBuyCrypto && !isAmoPay" class="amount-range-frame">
        <ul class="slider-number">
          <li
            v-for="(price, key) in priceList.slice(0, 5)"
            :key="key"
            @click="$emit('select-amount', price)"
          >
            {{ price | numberFormat }}
          </li>
        </ul>
        <ul class="slider-dot">
          <li
            v-for="(price, key) in priceList.slice(0, 5)"
            :key="key"
            @click="$emit('select-amount', price)"
          >
            <img :src="$getThemeImagePath('dot.svg')" alt="">
          </li>
        </ul>
        <div class="slider-bar" />
        <div
          v-show="selectedAmount"
          class="slider-bar og"
          :style="{ width: percent + '%' }"
        >
          <img :src="$getThemeImagePath('dot-orange.svg')" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DepositAmountInput',
  props: {
    /** 金額（父層 v-model） */
    amount: {
      type: [String, Number],
      default: 0
    },
    /** 目前選中的固定金額（PayPal / slider 用） */
    selectedAmount: {
      type: [String, Number],
      default: null
    },
    /** slider 進度百分比 */
    percent: {
      type: Number,
      default: 0
    },
    /** 渠道 typeNum (3 = 加密幣) */
    typeNum: {
      type: Number,
      default: 0
    },
    /** 渠道 typeCode，如 'PayPal' / 'JetonCash' / 'MaShangPay' */
    typeCode: {
      type: String,
      default: ''
    },
    /** 渠道 code，如 'AmoPay' */
    paymentCode: {
      type: String,
      default: ''
    },
    /** 金額列表（PayPal 固定金額 / 買幣 slider 用） */
    priceList: {
      type: Array,
      default: () => []
    },
    /** 是否為買幣模式 */
    isBuyCrypto: {
      type: Boolean,
      default: false
    },
    /** 是否顯示 "金額：" label（PC 版為 true） */
    showLabel: {
      type: Boolean,
      default: false
    },
    /** 是否顯示範圍提示列（Mobile 版為 true） */
    showRangeBar: {
      type: Boolean,
      default: false
    },
    amountMin: {
      type: [String, Number],
      default: 0
    },
    amountMax: {
      type: [String, Number],
      default: 0
    },
    /** 站長幣別（brand.currency，如 'JPY' / 'USD' / 'EUR'） */
    currency: {
      type: String,
      default: ''
    }
  },
  computed: {
    isAmoPay() {
      return this.paymentCode === 'AmoPay'
    },
    /** 依站長幣別顯示符號，無對應則直接顯示幣別代碼 */
    currencySymbol() {
      return { JPY: '¥', USD: '$', EUR: '€' }[this.currency] || this.currency
    }
  }
}
</script>
